var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"sorting-select"},[_c('vb-select',{attrs:{"value":_vm.sort,"vb_options":{
      options: _vm.options,
      value: _vm.sort,
    }},on:{"change":(value) => _vm.$emit('order', value)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }